<template>
  <div id="Zbcp">
    <div class="header">
      <el-form :inline="true" class="demo-form-inline forms">
        <el-form-item label="地区：">
          <el-cascader
            placeholder="--选择地区--"
            size="large"
            :options="options"
            v-model="queryForm.region"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="经销商：" prop="partnerId">
          <el-select
            v-model="queryForm.partnerId"
            clearable
            filterable
            remote
            :remote-method="getPartnerData"
            placeholder="--选择经销商--"
          >
            <el-option
              v-for="item in partnerList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="产品类型：" prop="type">
          <el-select
            v-model="queryForm.type"
            multiple
            filterable
            clearable
            remote
            reserve-keyword
            :remote-method="handleGetProduct"
            placeholder="--选择产品类型--"
          >
            <el-option
              v-for="item in productIdList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search">搜索</el-button>
          <el-button type="primary" @click="reset">重置</el-button>
          <el-button type="primary" @click="add">添加</el-button>
          <!-- <el-button type="primary" @click="download">打印</el-button> -->
        </el-form-item>
      </el-form>
    </div>
    <div class="table">
      <div class="content">
        <el-table :data="tableData" style="width: 100%" ref="table">
          <el-table-column prop="id" label="编号"> </el-table-column>
          <el-table-column prop="name" label="技师姓名"> </el-table-column>
          <el-table-column prop="newType" label="技师类型"> </el-table-column>
          <el-table-column prop="start" label="技师星级"> </el-table-column>
          <el-table-column
            prop="regionName"
            label="地区"
            key="regionName"
          ></el-table-column>
          <el-table-column
            prop="partnerName"
            key="partnerName"
            label="经销商"
          ></el-table-column>
          <el-table-column
            prop="createdAt"
            key="createdAt"
            label="创建时间"
          ></el-table-column>
          <el-table-column width="150" prop="" label="操作">
            <template slot-scope="scope">
              <span @click="bj(scope.$index, scope.row)" class="btns"
                >编辑</span
              >
              <span @click="sc(scope.$index, scope.row)" class="btns"
                >删除</span
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="button">
        <el-pagination
          background
          layout="prev, pager, next,jumper"
          @current-change="current_change"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>

    <el-dialog
      title="修改技师"
      :visible.sync="editFormVisible"
      :close-on-click-modal="false"
      class="edit-form"
      :before-close="handleClose"
    >
      <el-form
        :model="editForm"
        label-width="120px"
        ref="editForm"
        :rules="rules"
      >
        <el-form-item class="ts">
          <el-form-item label="姓名：" prop="name">
            <el-input v-model.trim="editForm.name"></el-input>
          </el-form-item>
          <el-form-item label="技师星级：" prop="start">
            <el-select v-model="editForm.start" placeholder="--选择技师星级--">
              <el-option
                v-for="(item, index) in StarsList"
                :key="index"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form-item>
        <el-form-item class="ts">
          <el-form-item label="产品类型：" prop="type">
            <el-select
              v-model="editForm.type"
              multiple
              filterable
              clearable
              remote
              reserve-keyword
              :remote-method="handleGetProduct"
              placeholder="--选择产品类型--"
            >
              <el-option
                v-for="item in productIdList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="经销商：" prop="partnerId">
            <el-select
              clearable
              filterable
              remote
              :remote-method="getPartnerData"
              v-model="editForm.partnerId"
              placeholder="--选择经销商--"
            >
              <el-option
                v-for="partItem in partnerList"
                :key="partItem.id"
                :label="partItem.name"
                :value="partItem.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form-item>
        <el-form-item label="地区：" prop="region">
          <el-cascader
            placeholder="--选择地区--"
            size="large"
            :options="options"
            v-model="editForm.region"
          ></el-cascader>
        </el-form-item>

        <el-form-item label="照片：" :required="true">
          <span>建议1寸照片电子档</span>
          <el-upload
            :class="imagesWF.length > 0 ? 'hide1' : ''"
            action=""
            list-type="picture-card"
            accept="image/*"
            :multiple="false"
            :limit="1"
            :auto-upload="false"
            :file-list="imagesWF"
            :on-change="handleWFOnchange"
            :on-remove="handleWFRemove"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="handleCancel('editForm')">取消</el-button>
        <el-button type="primary" @click.native="handleUpdate('editForm')"
          >更新</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      title="添加技师"
      :visible.sync="newData"
      :close-on-click-modal="false"
      class="edit-form"
      :before-close="newClose"
    >
      <el-form
        :model="newForm"
        label-width="120px"
        ref="newForm"
        :rules="rules"
      >
        <el-form-item class="ts">
          <el-form-item label="姓名：" prop="name">
            <el-input v-model.trim="newForm.name"></el-input>
          </el-form-item>
          <el-form-item label="技师星级：" prop="start">
            <el-select v-model="newForm.start" placeholder="--选择技师星级--">
              <el-option
                v-for="(item, index) in StarsList"
                :key="index"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form-item>
        <el-form-item class="ts">
          <el-form-item label="产品类型：" prop="type">
            <!-- <el-input v-model.trim="newForm.Sex"></el-input> -->
            <el-select
              v-model="newForm.type"
              multiple
              filterable
              clearable
              remote
              reserve-keyword
              :remote-method="handleGetProduct"
              placeholder="--选择产品类型--"
            >
              <el-option
                v-for="item in productIdList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="经销商：" prop="partnerId">
            <el-select
              v-model="newForm.partnerId"
              placeholder="--选择经销商--"
              clearable
              filterable
              remote
              :remote-method="getPartnerData"
            >
              <el-option
                v-for="partItem in partnerList"
                :key="partItem.id"
                :label="partItem.name"
                :value="partItem.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form-item>
        <el-form-item label="地区：" prop="region">
          <el-cascader
            placeholder="--选择地区--"
            size="large"
            :options="options"
            v-model="newForm.region"
          ></el-cascader>
        </el-form-item>

        <el-form-item label="照片：" :required="true">
          <span>建议1寸照片电子档</span>
          <el-upload
            :class="imagesWF.length > 0 ? 'hide1' : ''"
            action=""
            list-type="picture-card"
            accept="image/*"
            :multiple="false"
            :limit="1"
            :auto-upload="false"
            :file-list="imagesWF"
            :on-change="handleWFOnchange"
            :on-remove="handleWFRemove"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="newCancel('newForm')">取消</el-button>
        <el-button type="primary" @click.native="newUpdate('newForm')"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getJS, getYYS, getCPLX } from "./../axios/api";
import areaData from "../utils/china-area.json";
import moment from "dayjs";
export default {
  name: "Js",
  data() {
    return {
      options: areaData, // 地区
      partnerList: [], // 经销商
      productIdList: [], // 产品类型
      imagesWF: [],
      StarsList: [1, 2, 3, 4, 5],
      editFormVisible: false, //弹框
      newData: false, //弹框
      queryForm: {
        region: "",
        type: [],
        partnerId: null,
      },
      editForm: {
        name: "",
        region: "",
        start: null,
        type: [],
        partnerId: null,
      }, //弹框数据
      newForm: {
        name: "",
        region: "",
        start: null,
        type: [],
        partnerId: null,
      },
      loading: true,
      total: 0, //默认数据总数
      pagesize: 10, //每页的数据条数
      currentPage: 1, //默认开始页面
      tableData: [],
      rules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        region: [{ required: true, message: "请输入地区", trigger: "change" }],
        start: [{ required: true, message: "请选择星级", trigger: "change" }],
        type: [
          { required: true, message: "请选择产品类型", trigger: "change" },
        ],
        partnerId: [
          { required: true, message: "请选择经销商", trigger: "change" },
        ],
      },
    };
  },
  methods: {
    // 上传图片时的钩子
    handleWFOnchange(file, fileList) {
      var that = this;
      const formData = new FormData();
      if (file) {
        formData.append("file", file.raw);
      }
      // console.log(formData.get('file'))

      getJS
        .upload(formData)
        .then(function (res) {
          // console.log(res);
          if (res.code !== 0) {
            that.$alert(res.message + "!", "提示", {
              confirmButtonText: "确定",
            });
          } else {
            // console.log(res.data)

            that.imagesWF.push(res.data);

            that.$message.success("上传成功!");
          }
        })
        .catch(function (res) {});
    },
    // 上传图片的删除
    handleWFRemove(file, fileList) {
      if (fileList) {
        this.imagesWF = fileList;
      }
    },
    // 获取产品类型
    handleGetProduct(query) {
      let that = this;
      getCPLX
        .getTable({
          pageNumber: 1,
          pageSize: 1000,
          name: query || undefined,
        })
        .then(function (res) {
          // console.log(res)
          if (res.code !== 0) {
            that.$alert(res.message + "!", "提示", {
              confirmButtonText: "确定",
            });
          } else {
            const { list } = res.data;
            // console.log(list);

            that.productIdList = list;

            localStorage.setItem("productIdList", JSON.stringify(list));
          }
        });
    },
    // 获取经销商
    getPartnerData(query) {
      var that = this;

      //获取经销商列表
      let data = {
        pageNumber: 1,
        pageSize: 1000,
        name: query || undefined,
      };
      // console.log(data)
      getYYS.getTable(data).then(function (res) {
        if (res.code !== 0) {
          that.$alert(res.message + "!", "提示", {
            confirmButtonText: "确定",
          });
        } else {
          let { list } = res.data;
          // console.log(list);

          that.partnerList = list;
        }
      });
    },

    search: function () {
      this.currentPage = 1;
      this.init();
    },
    reset: function () {
      this.queryForm = {
        type: [],
      };
      this.currentPage = 1;
      this.init();
    },

    add: function () {
      this.newData = true; //显示弹框

      this.getPartnerData(); // 获取经销商

      this.handleGetProduct(); // 获取产品类型
    },
    //点击关闭dialog
    newClose(done) {
      this.imagesWF = [];
      this.newData = false;
      this.$refs["newForm"].resetFields();

      this.getPartnerData(); // 获取经销商

      this.handleGetProduct(); // 获取产品类型
    },
    //点击取消
    newCancel(formName) {
      this.imagesWF = [];
      this.newData = false;
      this.$refs["newForm"].resetFields();

      this.getPartnerData(); // 获取经销商

      this.handleGetProduct(); // 获取产品类型
    },
    //点击添加
    newUpdate(forName) {
      var that = this;
      if (that.imagesWF.length == 0) {
        this.$message.warning("请上传图片!");
      } else {
        this.$refs["newForm"].validate((valid) => {
          if (valid) {
            // 处理图片
            let newImages = [];
            that.imagesWF.map((img) => {
              newImages.push(img.url);
            });

            // 处理地区
            let region = that.newForm.region.join("");

            let data = {
              name: that.newForm.name,
              region: region,
              photo: newImages.toString(),
              start: that.newForm.start,
              type: that.newForm.type,
              partnerId: that.newForm.partnerId,
            };

            console.log(data);
            // return;
            getJS
              .addTable(JSON.stringify(data))
              .then(function (res) {
                if (res.code !== 0) {
                  that.$alert(res.message + "!", "提示", {
                    confirmButtonText: "确定",
                  });
                } else {
                  that.$message.success("添加成功!");
                  that.newData = false;
                  that.newForm = {};
                  that.$refs["newForm"].resetFields();
                  that.imagesWF = [];
                  that.init();
                }
              })
              .catch(function (res) {});
          } else {
            console.log("error submit!!");
            return false;
          }
        });
      }
    },
    current_change: function (currentPage) {
      this.currentPage = currentPage;
      this.init();
    },

    //点击编辑
    bj: function (index, row) {
      var that = this;
      console.log(row);
      var that = this;
      this.editFormVisible = true; //显示弹框
      that.editForm.id = row.id;

      that.editForm = row;

      // 区域
      let province = row.region.slice(0, 2);
      let town = row.region.slice(2, 6);
      let district = row.region.slice(6, 12);
      that.editForm.region = [province, town, district];

      // 图片
      let newData = [];
      let newImage = {};
      newImage.url = row.photo;
      newData.push(newImage);

      // console.log(newData)
      this.imagesWF = newData;

      // 产品

      that.getPartnerData(); // 获取经销商

      that.handleGetProduct(); // 获取产品类型

    },
    //点击关闭dialog
    handleClose(done) {
      this.editFormVisible = false;
      this.$refs["editForm"].clearValidate();
      this.imagesWF = [];

      this.getPartnerData(); // 获取经销商

      this.handleGetProduct(); // 获取产品类型
    },
    //点击取消
    handleCancel(formName) {
      this.editFormVisible = false;
      this.$refs["editForm"].clearValidate();
      this.imagesWF = [];

      this.getPartnerData(); // 获取经销商

      this.handleGetProduct(); // 获取产品类型
    },
    //点击更新
    handleUpdate(forName) {
      var that = this;
      if (this.imagesWF.length == 0) {
        this.$message.warning("请上传图片!");
      } else {
        this.$refs["editForm"].validate((valid) => {
          if (valid) {
            let newImages = [];
            that.imagesWF.map((img) => {
              newImages.push(img.url);
            });

            // 处理地区
            let region = that.editForm.region.join("");

            let data = {
              name: that.editForm.name,
              region: region,
              photo: newImages.toString(),
              start: that.editForm.start,
              type: that.editForm.type,
              partnerId: that.editForm.partnerId,
            };
            getJS
              .editTable(data, that.editForm.id)
              .then(function (res) {
                if (res.code !== 0) {
                  that.$alert(res.message + "!", "提示", {
                    confirmButtonText: "确定",
                  });
                } else {
                  that.$message.success("更新成功!");
                  that.editFormVisible = false;
                  that.$refs["editForm"].clearValidate();
                  that.imagesWF = [];
                  that.init();
                }
              })
              .catch(function (res) {
                that.editFormVisible = false;
                that.$refs["editForm"].clearValidate();
                // console.log(res)
                that.$alert(res.message + "!", "提示", {
                  confirmButtonText: "确定",
                });
              });
          } else {
            console.log("error submit!!");
            return false;
          }
        });

        //更新的时候就把弹出来的表单中的数据写到要修改的表格中

        // console.log(data)
      }
    },
    //点击删除
    sc: function (index, row) {
      console.log(row);
      var that = this;
      this.$confirm("此操作将永久删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          getJS
            .delTable({
              id: row.id,
            })
            .then(function (res) {
              if (res.code !== 0) {
                that.$alert(res.message + "!", "提示", {
                  confirmButtonText: "确定",
                });
              } else {
                that.currentPage = 1;
                that.init();
                that.$message({
                  type: "success",
                  message: "删除成功!",
                });
              }
            })
            .catch(function (res) {
              that.$message({
                type: "info",
                message: res.message,
              });
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },

    init: function () {
      var that = this;
      that.loading = true;
      let data = {
        type:
          that.queryForm.type.length !== 0
            ? that.queryForm.type.toString()
            : undefined,
        partnerId: that.queryForm.partnerId
          ? that.queryForm.partnerId
          : undefined,
        region: that.queryForm.region
          ? that.queryForm.region.join("")
          : undefined,
        pageSize: that.pagesize,
        pageNumber: that.currentPage,
      };

      // console.log(data);
      // return;
      getJS.getTable(data).then(function (res) {
        if (res.code !== 0) {
          that.$alert(res.message + "!", "提示", {
            confirmButtonText: "确定",
          });
        } else {
          const { list, totalNumber } = res.data;
          list.map((lis) => {
            let addr = "";
            let province = lis.region.slice(0, 2);
            let town = lis.region.slice(2, 6);
            let district = lis.region.slice(6, 12);

            lis.createdAt = moment(new Date(lis.createdAt * 1000)).format(
              "YYYY-MM-DD"
            );

            lis.newType = [];
            let productIdList = JSON.parse(
              localStorage.getItem("productIdList")
            );

            lis.type.map((type) => {
              productIdList.map((pro) => {
                if (type == pro.id) {
                  lis.newType.push(pro.name);
                }
              });
              // lis.newType.push(type);
            });

            lis.newType = lis.newType.toString();
            // console.log(lis.newType);

            that.options.map((item1) => {
              if (item1.value === province) {
                addr += item1.label;
                item1.children.map((item2) => {
                  if (item2.value === town) {
                    addr += item2.label;
                    item2.children.map((item3) => {
                      if (item3.value === district) {
                        addr += item3.label;
                      }
                    });
                  }
                });
              }
            });

            lis.regionName = addr;
          });
          // console.log(list);
          that.total = totalNumber;
          that.tableData = list;
          that.loading = false;
        }
      });

      that.getPartnerData(); // 获取经销商

      that.handleGetProduct(); // 获取产品类型
    },
  },
  mounted() {
    var that = this;

    that.init();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/page/Js.vue